var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"root",staticClass:"reverse-geocoding",attrs:{"aria-busy":_vm.loading ? 'true' : 'false'}},[(_vm.skeleton && _vm.loading)?_c('text-skeleton',{attrs:{"lines":_vm.skeletonLines}}):[_vm._v(_vm._s(_vm.address))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }